const API_HOST =
  process.env.REACT_APP_API_HOST ||
  (process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://api.enc-worksphere.com');

export const apiUrl = {
    HOST: API_HOST,
    LOGIN_URL: `/api/auth/login`,
    MASTER_SUBTEAM_URL:`/api/project-detail/subteam/`,
    REFRESH_TOKEN_URL: `/api/auth/refresh_token/`,
    REGISTER_NEW_PROJECT_URL: `/api/project-detail/register-project/`,
    EDIT_PROJECT_URL: `/api/project-detail/edit-project/`,
    MEMBER_SEARCH_URL: `/api/project-member/member-search/`,
    ADD_MEMBER_URL: `/api/project-member/add-member/`,
    FIND_MANAGER_URL: `/api/project-member/find-manager/`,
    MEMBERS_URL: `/api/project-member/members/`,
    DELETE_MEMBER_URL: `/api/project-member/member/`,
    UPSERT_TARGET_SAVING_URL: `/api/project-cost-saving/add-target-saving/`,
    UPSERT_TARGET_SAVING_ARRAY_URL: `/api/project-cost-saving/upsert-target-saving/`,
    UPSERT_ACTUAL_SAVING_URL: `/api/project-cost-saving/add-actual-saving/`,
    UPSERT_ACTUAL_SAVING_ARRAY_URL: `/api/project-cost-saving/upsert-actual-saving/`,
    GEN_SAVING_MONTH_YEAR_URL: `/api/project-cost-saving/gen-saving/`,
    CHANGE_SAVING_TYPE_URL: `/api/project-cost-saving/change-saving-type/`,
    GET_SAVING_URL: `/api/project-cost-saving/`,
    GET_SAVING_TYPE_URL: `/api/project-cost-saving/type/`,
    PROJECT_SUMMARY_URL: `/api/projects/projects/`,
    ALL_PROJECT_SUMMARY_URL: `/api/projects/all-projects/`,
    ALL_PROJECTS_SUMMARY_URL: `/api/projects/all-projects/summary`,
    TEAM_PROJECTS_SUMMARY_URL: `/api/projects/team-projects/summary`,
    PROJECT_FORM_URL: `/api/projects/project/`,
    DELETE_PROJECT_URL: `/api/projects/project/`,
    DELETE_MANAGER_URL: `/api/project-detail/delete-project-manager/`,
    ADD_PROGRESS_URL: `/api/project-progress/add-progress/`,
    LATEST_PROGRESS_URL: `/api/project-progress/get-latest-progress/`,
    ALL_PROGRESS_URL: `/api/project-progress/get-progress/`,
    DELETE_PROGRESS_URL: `/api/project-progress/delete-progress/`,
    BU_PROJECT_DONUT_URL: `/api/report-bu/projects-by-bu/`,
    BU_SAVING_COLUMN_URL: `/api/report-bu/savings-by-bu/`,
    BU_SUMMARY_TABLE_URL: `/api/report-bu/summary-bu-savings/`,
    TEAM_PROJECT_DONUT_URL: `/api/report-team/projects-by-team/`,
    TEAM_SAVING_COLUMN_URL: `/api/report-team/savings-by-team/`,
    TEAM_SUMMARY_TABLE_URL: `/api/report-team/summary-team-savings/`,
    PROJECTS_STATUS_URL: `/api/report-status/status-by-projects/`,
    TEAMS_STATUS_URL: `/api/report-status/status-by-teams/`,
    PROJECTS_PERCENT_RANGE_STATUS_URL: `/api/report-status/percent-range-status-by-projects/`,
    TEAMS_PERCENT_RANGE_STATUS_URL: `/api/report-status/average-progress-status-by-teams/`,
    COST_SAVINGS_URL: `/api/report-cost-saving/savings-year-month/`,
    TEAM_COST_SAVINGS_URL: `/api/report-cost-saving/savings-teams/`,

    // Admin
    ADMIN_IMPORT_PROJECT_INFO_URL: `/api/admin/project-info/import`,

  };
  